import {getCurrentInstance, ref} from "vue";
import helpers from "@/lib/helpers";
import store from "@/store";
import PasteContactModal from "./paste-contact-modal.vue";
import {saveContacts, saveAddress} from "./saveContacts";

export function useAddress(url) {
    const addresses = ref([])
    const refresh = () => {
        helpers.asyncAction(url, 'GET').then((v) => addresses.value = v)
    }
    return {addresses, refresh}
}

export function useContact(url) {
    const contacts = ref([])
    const refresh = () => {
        helpers.asyncAction(url, 'GET').then((v) => contacts.value = v)
    }
    const type_text = (type) => {
        switch (type) {
            case 'B':
                return 'eBay User ID'
            case 'P':
                return 'Phone Number'
            case 'E':
                return 'Email'
            default:
                return 'Invalid'
        }
    }
    const icon = (type) => {
        switch (type) {
            case 'B':
                return ['fab', 'ebay']
            case 'P':
                return ['fas', 'phone']
            case 'E':
                return ['far', 'envelope']
            default:
                return ['fas', 'question-circle']
        }
    }


    return {icon, type_text, contacts, refresh}
}

/**
 * The Paste button on a record page.
 *
 * Same dialog the Contacts and Addresses managers use, but applied straight to
 * the record and followed by a reload - there is no inline form to drop the
 * address into out here. The dialog itself is the review step: the user has
 * already corrected the parse before this writes anything.
 */
export function usePasteContact() {
    const dialog = getCurrentInstance().proxy.$dialog

    const pasteBlock = async ({contactUrl, addressUrl, intro} = {}) => {
        const targets = []

        if (contactUrl)
            targets.push(
                {key: 'emails', label: 'Save emails as contacts', needs: 'email'},
                {key: 'phones', label: 'Save phone numbers as contacts', needs: 'phone'},
            )

        if (addressUrl)
            targets.push({key: 'address', label: 'Save the postal address', needs: 'address'})

        const parsed = await dialog.showAndWait(PasteContactModal, {
            intro: intro || 'Paste an address, an email signature or a business card. Tick what should be saved to this record.',
            targets,
        })

        if (!parsed)
            return 0

        const t = parsed.targets || {}
        let changes = 0

        if (contactUrl)
            changes += await saveContacts(contactUrl, parsed, t)

        if (addressUrl && t.address && await saveAddress(addressUrl, parsed))
            changes++

        if (changes)
            store.dispatch('record_load')

        return changes
    }

    return {pasteBlock}
}

export function useDefaultContact(form, modify, save) {
    const dialog = getCurrentInstance().proxy.$dialog

    const choosePrimary = async (modal, url_key, key, type) => {
        const result = await dialog.showAndWait(modal, {url: modify.value._links[url_key].href, filter: type})
        if (!result)
            return

        form[key] = result.id
        save()
    }

    const clearPrimary = (key) => {
        form[key] = null
        save()
    }

    return {clearPrimary, choosePrimary}
}